// Custom project scripts

$(document).ready(function(){
	init_duk();
});

function init_duk() {
	
	$('.category').click(function(){		
		$(this).parent().find('.category_questions').slideToggle();
		$(this).children('.catNameOuter').toggleClass('act');
	});
	
	$('.question').click(function(){
		$(this).parent().find('.answer').slideToggle();
		$(this).children('.questionNameOuter').toggleClass('act');
	});
	//form
	$('.show_form').click(function(){
		if($('.submit_form').hasClass('hidden')){ //this is the start of our condition 
			$('.submit_form').show('fast').slideDown();
			$('.submit_form').removeClass('hidden');
		} else {
			$('.submit_form').hide('fast').slideUp();
			$('.submit_form').addClass('hidden');
		}
	});
    
}
